import { EyeIcon, EyeSlashIcon } from '@phosphor-icons/react'

import { deliveryMethodVisibility } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/constants'
import { returnInstructionTypes } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/ReturnInstructions/ReturnInstructionsConfiguration/constants'

import { returnMethods } from '../constants'

export const visibilityCards = [
  {
    value: deliveryMethodVisibility.public,
    title: 'Público',
    description: 'Visible para los clientes en el portal',
    Icon: EyeIcon,
  },
  {
    value: deliveryMethodVisibility.internal,
    title: 'Privado',
    description: 'No visible para los clientes en el portal',
    Icon: EyeSlashIcon,
  },
]

export const visibilityInputName = 'visibility'

export const returnMethodToInstructionType = {
  [returnMethods.customerpickup]: returnInstructionTypes.homePickup,
  [returnMethods.customerdelivers]: returnInstructionTypes.shipItYourself,
  [returnMethods.pickuppoint]: returnInstructionTypes.dropoffPoint,
  [returnMethods.returntostore]: returnInstructionTypes.storeDropoff,
}
